import ticketDetails from '../localization-messages/ticketDetails/it-IT.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/it-IT.json';
import ticketListing from '../localization-messages/ticketListing/it-IT.json';
import ticketForm from '../localization-messages/ticketForm/it-IT.json';
import headerFooter from '../localization-messages/headerFooter/it-IT.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/it-IT.json';
import termsModal from '../localization-messages/termsModal/it-IT.json';

export const itITTranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
